export default "__VITE_ASSET__xLYgBsNL__"